import { Icon, IconsEnum, toIconsEnum } from 'components/Icons';
import { getUrlManifestazioneByAvvenimento } from 'features/sport';

import { AppFragment } from 'enums/path-fragment';
import { AvailableStreamCardBody } from './components/availableStreamCardBody';
import { AvailableStreamCardFooter } from './components/availableStreamCardFooter';
import { AvailableStreamCardHeader } from './components/availableStreamCardHeader';
import { Button } from 'components/button';
import { TimingLivePreMatch } from 'components/timingLivePreMatch';
import { memo } from 'react';
import { mergeCompetitorWithScore } from '../scommesseInEvidenceCard/utils/utils';
import styles from './AvailableStreamCard.module.scss';
import { toSportUrlCase } from 'utility/functions';
import { useAvvenimento } from 'features/sport/hooks';
import { useRouter } from 'next/router';
import { useTranslation } from 'hooks/useLingUI';

export type AvailableStreamCardProps = {
  avvenimentoKey?: string;
};

export const AvailableStreamCard = memo(function AvailableStreamCardCard({ avvenimentoKey }: AvailableStreamCardProps) {
  const { t } = useTranslation();
  const { push } = useRouter();

  // TODO : PAS : infoAggiuntivaMap - verificare
  const maybeAvvenimento = useAvvenimento(avvenimentoKey);

  if (maybeAvvenimento) {
    const {
      key,
      live,
      slug,
      idDisciplina,
      slugDisciplina,
      firstCompetitor,
      secondCompetitor,
      slugManifestazione,
      descrizioneManifestazione,
      descrizioneManifestazioneTrKey,
    } = maybeAvvenimento ?? {};

    const urlLink = `${slug}`.toLowerCase().startsWith(`${AppFragment.Live}/`)
      ? toSportUrlCase(maybeAvvenimento.slug)
      : getUrlManifestazioneByAvvenimento(maybeAvvenimento);

    const disciplina = `DISCIPLINA_${idDisciplina}`;

    return (
      <div className={styles.container}>
        <AvailableStreamCardHeader
          disciplinaIcon={toIconsEnum(disciplina)}
          manifestazioneLabel={`${descrizioneManifestazione ?? slugManifestazione}`}
          manifestazioneLabelTrKey={descrizioneManifestazioneTrKey}
          urlManifestazione={`${slugDisciplina}/${slugManifestazione}`}
        >
          <TimingLivePreMatch avvenimentoKey={key} />
        </AvailableStreamCardHeader>
        <AvailableStreamCardBody
          dataList={mergeCompetitorWithScore([firstCompetitor ?? {}, secondCompetitor ?? {}], live?.score)}
          urlAvvenimento={urlLink}
        />
        <AvailableStreamCardFooter>
          <div className={styles.quoteContainer}>
            <Button size="small" visualizationType="primary" onClick={() => push(urlLink!)}>
              <span className={styles.buttonLiveStream} suppressHydrationWarning={true}>
                <Icon iconId={IconsEnum.STREAMING} className={styles.icon} />
                {t('watch-live')}
              </span>
            </Button>
          </div>
        </AvailableStreamCardFooter>
      </div>
    );
  }
  return null;
});
